import { Injectable } from "@angular/core";
import { CanActivate, CanActivateChild } from "@angular/router";
import { Store } from "@ngrx/store";
import { AuthSelector, CoreState } from "@obg/ngx.core";
import { combineLatest, Observable, of } from "rxjs";
import { switchMap } from "rxjs/operators";

import { AwsGeofencingService } from "./aws-geofencing.service";

@Injectable({ providedIn: "root" })
export class AwsGeofencingGuard implements CanActivateChild, CanActivate {
	constructor(
		private store: Store<CoreState>,
		private awsGeofencingService: AwsGeofencingService
	) {}

	canActivate(): Observable<boolean> {
		return combineLatest([this.store.select(AuthSelector.isAuthenticated)]).pipe(
			switchMap(([isAuth]) => {
				if (!isAuth) {
					return of(true);
				}

				return this.awsGeofencingService.isAccessAllowed$();
			})
		);
	}

	canActivateChild(): Observable<boolean> {
		return this.canActivate();
	}
}
